module.exports = __webpack_public_path__ + "img/android-ar.801c9081.png";